import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

import { BaMenuService } from '../../services';
import { GlobalState } from '../../../global.state';
import { MatSidenav } from '@angular/material/sidenav';
//import 'style-loader!./baMenu.scss';

@Component({
  selector: 'ba-menu',
  templateUrl: './baMenu.html',
  styleUrls: ['./baMenu.scss'],
})
export class BaMenu {
  @Input() sidebarCollapsed: boolean = false;
  @Input() menuHeight: number = 0;

  @Output() expandMenu = new EventEmitter<any>();

  public menuItems: any[] = [];
  protected _menuItemsSub!: Subscription;
  public showHoverElem: boolean = false;
  public hoverElemHeight: number = 0;
  public hoverElemTop: number = 0;
  protected _onRouteChange!: Subscription;
  public outOfArea: number = -200;

  constructor(
    private _router: Router,
    private _service: BaMenuService,
    private _state: GlobalState
  ) {}

  public updateMenu(newMenuItems: any) {
    this.menuItems = newMenuItems;
    console.log({ updatemenubind: this.menuItems, newMenuitems: newMenuItems });
    this.selectMenuAndNotify();
  }

  public selectMenuAndNotify(): void {
    console.log({
      selectMenuAndNotify: {
        menuitems: this.menuItems,
        state: this._state,
        service: this._service,
      },
    });
    if (this.menuItems) {
      this.menuItems = this._service.selectMenuItem(this.menuItems);
      this._state.notifyDataChanged(
        'menu.activeLink',
        this._service.getCurrentItem()
      );
    }
  }

  public ngOnInit(): void {
    this._onRouteChange = this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.menuItems) {
          this.selectMenuAndNotify();
        } else {
          // on page load we have to wait as event is fired before menu elements are prepared
          console.log({ onpagemenuitems: this.menuItems });
          setTimeout(() => this.selectMenuAndNotify());
        }
      }
    });

    this._menuItemsSub = this._service.menuItems.subscribe(
      this.updateMenu.bind(this)
    );
  }

  public ngOnDestroy(): void {
    this._onRouteChange.unsubscribe();
    this._menuItemsSub.unsubscribe();
  }

  public hoverItem($event: any): void {
    this.showHoverElem = true;
    this.hoverElemHeight = $event.currentTarget.clientHeight;
    // TODO: get rid of magic 66 constant
    this.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - 66;
  }

  public toggleSubMenu($event: any): boolean {
    let submenu = jQuery($event.currentTarget).next();

    if (this.sidebarCollapsed) {
      this.expandMenu.emit(null);
      if (!$event.item.expanded) {
        $event.item.expanded = true;
      }
    } else {
      $event.item.expanded = !$event.item.expanded;
      submenu.slideToggle();
    }

    return false;
  }
}
